import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { OrganizationAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';

@Injectable()
export class AdminOfOrganizationService {
    constructor(private authService: AuthService, private http: Http) { }
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();

    public GetAdminOfOrganizationList(organizationHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getOrganizationAdminUrl = WeGoConfig.API_GET_ADMIN_OF_ORGANIZATION_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getOrganizationAdminUrl = getOrganizationAdminUrl + "?" + queryString + "&organizationHashID=" + organizationHashID;
        }
        else {
            getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getOrganizationAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfOrganization(organizationHashID: string, selectedAdminOfCustomerList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfOrganization = WeGoConfig.API_POST_DELETE_ADMIN_OF_ORGANIZATION + "?organizationHashID=" + organizationHashID;

        return this.http.post(urlDeleteAdminOfOrganization, selectedAdminOfCustomerList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportAdminOfOrganizationList(organizationHashID: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let exportToCSVOrganizationAdminUrl = WeGoConfig.API_EXPORT_ADMIN_OF_ORGANIZATION_LIST + "?" + queryString + "&organizationHashID=" + organizationHashID;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(exportToCSVOrganizationAdminUrl, options);
    }

    public GetAllRoleAvailability(input?: DataListModel, organizationHashID?: string): Observable<IAPIResponse> {
        let getRoleAvailabilityListUrl = WeGoConfig.API_GET_ORGANIZATION_ROLEAVAILABILITY_LIST + "?organizationHashID=" + organizationHashID;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getRoleAvailabilityListUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfOrganizationRole(organizationHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfOrganization = WeGoConfig.API_POST_DELETE_ADMIN_OF_ORGANIZATION_ROLE + "?organizationHashID=" + organizationHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;

        return this.http.get(urlDeleteAdminOfOrganization, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddAdminOfOrganizationRole(organizationHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlAddAdminOfOrganization = WeGoConfig.API_POST_ADD_ADMIN_OF_ORGANIZATION_ROLE + "?organizationHashID=" + organizationHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;;

        return this.http.get(urlAddAdminOfOrganization, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetPersonListToInvite(organizationHashID: string, emailAddress: string): Observable<IAPIResponse> {
        let getOrganizationAdminUrl = WeGoConfig.API_GET_ORGANIZATION_PERSON_TO_INVITE_LIST;

        getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationHashID + "&emailAddress=" + emailAddress;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getOrganizationAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public InviteAdminOfOrganization(organizationAdminInvitationModel: OrganizationAdminInvitationModel): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlInviteAdminOfOrganization = WeGoConfig.API_POST_INVITE_ADMIN_OF_ORGANIZATION;

        return this.http.post(urlInviteAdminOfOrganization, organizationAdminInvitationModel, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-organization/models/admin-of-organization.service.ts